export const LanguageClearAndConcise = "LanguageClearAndConcise";
export const ReportAnswersAllTheQuestions = "ReportAnswersAllTheQuestions";
export const ReportSpecificEnough = "ReportSpecificEnough";
export const WereRecommendationsRealistic = "WereRecommendationsRealistic";
export const WereRecommendationsRealisticFurtherComments = "WereRecommendationsRealisticFurtherComments";
export const HowAccurateWasReturnToWorkDate = "HowAccurateWasReturnToWorkDate";
export const OverallExperience = "OverallExperience";
export const FurtherComments = "FurtherComments";
export const FeedbackContactConsent = "FeedbackContactConsent";
